import React, { useState } from 'react';
import { COLORS, inputStyle, handleInputFocus, handleInputBlur } from './signupStyles';

export const TagInput = ({ values = [], onChange, suggestions = [], placeholder }) => {
  const [query, setQuery] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  const filtered = suggestions
    .filter(s => s.toLowerCase().includes(query.toLowerCase()) && !values.includes(s))
    .slice(0, 6);

  const addTag = (tag) => {
    if (tag && !values.includes(tag)) {
      onChange([...values, tag]);
    }
    setQuery('');
  };

  const removeTag = (tag) => onChange(values.filter(v => v !== tag));

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && query.trim()) {
      e.preventDefault();
      addTag(filtered.length > 0 ? filtered[0] : query.trim());
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      {values.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
          {values.map(v => (
            <span key={v} style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              padding: '5px 10px', backgroundColor: `${COLORS.salmon}15`,
              border: `1px solid ${COLORS.salmon}40`, borderRadius: '16px',
              fontSize: '13px', color: COLORS.text
            }}>
              {v}
              <button onClick={() => removeTag(v)} type="button" style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: COLORS.salmon, fontSize: '16px', padding: 0, lineHeight: 1
              }}>&times;</button>
            </span>
          ))}
        </div>
      )}
      <input
        type="text"
        value={query}
        onChange={(e) => { setQuery(e.target.value); setShowDropdown(true); }}
        onFocus={(e) => { handleInputFocus(e); setShowDropdown(true); }}
        onBlur={(e) => { handleInputBlur(e); setTimeout(() => setShowDropdown(false), 200); }}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        style={inputStyle}
      />
      {showDropdown && query && filtered.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 10,
          backgroundColor: '#fff', border: `1px solid ${COLORS.border}`,
          borderRadius: '8px', marginTop: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          maxHeight: '180px', overflow: 'auto'
        }}>
          {filtered.map(s => (
            <div
              key={s}
              onMouseDown={() => addTag(s)}
              style={{ padding: '10px 14px', cursor: 'pointer', fontSize: '14px', color: COLORS.text }}
              onMouseEnter={(e) => { e.target.style.backgroundColor = '#f5f3f0'; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
            >{s}</div>
          ))}
        </div>
      )}
    </div>
  );
};
